import { render, staticRenderFns } from "./StaffInformation.vue?vue&type=template&id=0d8aea01"
import script from "./StaffInformation.vue?vue&type=script&setup=true&lang=js"
export * from "./StaffInformation.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports